export const searchPath = '/search' as const
export const searchSettingsPath = '/search-settings'
